import { StateDot } from '@/components/state-dot'

type AccountIndicatorProps = {
  isPaired: boolean
}

/**
 * Pairing-state dot for the partners table ("GTOW Acc" column).
 *
 * The marketing team's question at this cell is "can this partner log in?".
 * A green/red dot answers it at a glance; the tooltip carries the consequence
 * ("partner cannot log in or earn"). The raw `account_id` is never rendered —
 * a developer-facing number with no meaning to the audience.
 */
export const AccountIndicator = ({ isPaired }: AccountIndicatorProps) => (
  <StateDot
    offLabelId="admin.partners.account.unlinked"
    offTooltipId="admin.partners.account.unlinked.tooltip"
    on={isPaired}
    onLabelId="admin.partners.account.linked"
    onTooltipId="admin.partners.account.linked.tooltip"
  />
)
